import { Method } from 'axios';
import { Executable } from './executable';

/**
 * The AddPersonInput used by the constructor of AddPerson
 */
export interface AddPersonInput {
  /**
   * Bambu person identifier, if not provided email is required.
   */
  personId?: string;
  /**
   * email of the person, if not provided personId is required.
   */
  email?: string;
}

/**
 * The AddPerson response expected from the execution of the object within BambuClient execute.
 */
export interface AddPersonToTenantResponse {
  /**
   * the message response from the request
   */
  message: string;
  /**
   * any error messages that were returned by the request.
   */
  error?: any;
}

/**
 * The create person api is an asyncronous request to BambuMeta to issue the provided user an person.  This request
 * will not guarentee an person is created.  But checks if there is already an existing person.  If so, the person id is returned.  If no person already exists,
 * the request will be added to the processor for consumption and a success message should be returned.
 */
export class AddPerson extends Executable<AddPersonToTenantResponse> {
  /**
   * getMethod is used by the BambuClient to properly construct the request call.
   * @returns request method
   */
  public getMethod(): Method {
    return 'post';
  }

  /**
   * getResponse is used by the BambuClient to propery return the response object type.
   * @param apiResponse the api response object returned by the BambuMeta client before being converted to the AddPersonResponse
   * @returns AddPersonResponse
   */
  public getResponse(apiResponse: any): AddPersonToTenantResponse {
    return apiResponse;
  }

  /**
   * getURLPath is used by the BambuClient to properly construct the request call.
   * @param tenantId the tenant id defined in the BambuClient
   * @returns request url
   */
  public getURLPath(tenantId?: string): string {
    return `${tenantId}/add-person`;
  }

  private _personId?: string;

  constructor(input?: AddPersonInput) {
    super();
    if (input) {
      this._personId = input.personId;
    }
  }

  /**
   * Sets the bambu person identifier.
   * @param value <string> person id
   * @returns <AddPerson>
   */
  public setPersonId(value: string): AddPerson {
    this._personId = value;
    return this;
  }

  /**
   * getBody is used by the BambuClient to properly construct the request object body.
   * @returns Returns the expected body of the request utilizing the defined request attributes.
   */
  getBody(): any {
    return {
      personId: this._personId,
    };
  }

  /**
   * getRootPath is used by the BambuClient to properly construct the request call.
   * @returns The root path of the request
   */
  getRootPath(): string | undefined {
    return undefined;
  }
}
